import "./ClientAccountDetailsComponent.scss";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import LoaderComponent from "../../../../shared/components/loader/LoaderComponent";
import StatusCardComponent from "../../../../shared/components/status-card/StatusCardComponent";
import React from "react";
import DataLabelValueComponent from "../../../../shared/components/data-label-value/DataLabelValueComponent";
import PageHeaderComponent from "../../../../shared/components/page-header/PageHeaderComponent";
import CardV2Component from "../../../../shared/components/card-v2/CardV2Component";
import HorizontalLineV2Component from "../../../../shared/components/horizontal-line-v2/HorizontalLineV2Component";
import {CommonService} from "../../../../shared/services";
import {useNavigate} from "react-router-dom";

interface ClientAccountDetailsComponentProps {
}

const ClientAccountDetailsComponent = (props: ClientAccountDetailsComponentProps) => {

    const {
        clientCommunicationReferralDetails,
        isClientCommunicationReferralDetailsLoaded,
        isClientCommunicationReferralDetailsLoading,
        isClientCommunicationReferralDetailsLoadingFailed,
    } = useSelector((state: IRootReducerState) => state.client);
    const navigate = useNavigate();

    return (
        <div className={'client-account-details-component'}>
            {
                isClientCommunicationReferralDetailsLoading && <div>
                    <LoaderComponent/>
                </div>
            }
            {
                isClientCommunicationReferralDetailsLoadingFailed &&
                <StatusCardComponent title={"Failed to fetch client Details"}/>
            }
            {
                (isClientCommunicationReferralDetailsLoaded && clientCommunicationReferralDetails) && <>
                    <PageHeaderComponent title={'Preferences'} className={'pdd-left-10'}/>
                    <div className={'client-account-details-wrapper'}>
                        <CardV2Component title={"Communication Preferences"} showAction={true} actionTitle={'Edit'}
                                         onClick={() => navigate(CommonService._client.NavigateToClientEdit("accountDetails"))}
                        >
                            <div className={'ts-row'}>
                                <div className={'ts-col-5'}>
                                    <DataLabelValueComponent label={'Appointment Confirmations'}>
                                        {clientCommunicationReferralDetails?.communication_preferences?.appointment_confirmations_details?.title || "N/A"}
                                    </DataLabelValueComponent>
                                </div>
                                <DataLabelValueComponent label={'Appointment Reminders'}>
                                    {clientCommunicationReferralDetails?.communication_preferences?.appointment_reminders_details?.title || "N/A"}
                                </DataLabelValueComponent>
                            </div>
                        </CardV2Component>
                    </div>
                    <HorizontalLineV2Component/>
                    <CardV2Component title={"Referral Details"}>
                        <DataLabelValueComponent label={'How did you find us?'}>
                            {clientCommunicationReferralDetails?.referral_details.source_details?.title || "N/A"}
                        </DataLabelValueComponent>

                        {clientCommunicationReferralDetails?.referral_details.source_details?.code ===
                            "friends_family_colleague" && <>
                                <div className="ts-row">
                                    <div className="ts-col-4">
                                        <DataLabelValueComponent
                                            label={"First Name"}> {clientCommunicationReferralDetails?.referral_details?.source_info_first_name || "N/A"} </DataLabelValueComponent>
                                    </div>
                                    <div className="ts-col-4">
                                        <DataLabelValueComponent
                                            label={"Last Name"}> {clientCommunicationReferralDetails?.referral_details?.source_info_last_name || "N/A"} </DataLabelValueComponent>
                                    </div>
                                    <div className="ts-col-4">
                                        <DataLabelValueComponent
                                            label={"Phone Number"}> {clientCommunicationReferralDetails?.referral_details?.source_info_phone || "N/A"} </DataLabelValueComponent>
                                    </div>
                                    <div className="ts-col-4">
                                        <DataLabelValueComponent
                                            label={"Email"}> {clientCommunicationReferralDetails?.referral_details?.source_info_email || "N/A"} </DataLabelValueComponent>
                                    </div>
                                </div>
                                <div className={'ts-row'}>
                                    <div className="ts-col-3">
                                        <DataLabelValueComponent
                                            label={"Relationship"}> {clientCommunicationReferralDetails?.referral_details.source_info_relationship_details?.title || "N/A"} </DataLabelValueComponent>
                                    </div>
                                </div>

                            </>}
                        {
                            clientCommunicationReferralDetails?.referral_details.source_details?.code === "social_media" && <>
                                <DataLabelValueComponent
                                    label={"Platform"}> {clientCommunicationReferralDetails?.referral_details.platform || "N/A"} </DataLabelValueComponent>
                            </>
                        }
                        {
                            clientCommunicationReferralDetails?.referral_details.source_details?.code === "comment" && <>
                                <DataLabelValueComponent
                                    label={"Other"}> {clientCommunicationReferralDetails?.referral_details?.comment || "N/A"} </DataLabelValueComponent>
                            </>
                        }
                    </CardV2Component>
                </>
            }
        </div>
    );

};

export default ClientAccountDetailsComponent;
